var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"my-benefit-election-app"}},[_c('router-view',{staticClass:"ma-0 pa-0"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }